// src/constants/incidentStatus.js

/**
 * Presentation for incident status, in one place.
 *
 * Status labels are written from the reader's point of view — "Awaiting expert"
 * rather than "open" — because the raw enum leaks implementation detail and
 * tells neither party what happens next.
 */

const STATUS_META = {
  open: {
    label: "Awaiting expert",
    chipClass: "bg-sky-50 text-sky-700 border-sky-200",
    dotClass: "bg-sky-500",
  },
  assigned: {
    label: "Expert assigned",
    chipClass: "bg-blue-50 text-blue-700 border-blue-200",
    dotClass: "bg-blue-500",
  },
  "in-progress": {
    label: "Investigating",
    chipClass: "bg-blue-50 text-blue-700 border-blue-200",
    dotClass: "bg-blue-500 animate-pulse",
  },
  waiting_client_confirmation: {
    label: "Awaiting your confirmation",
    chipClass: "bg-amber-50 text-amber-700 border-amber-200",
    dotClass: "bg-amber-500",
  },
  waiting_expert_confirmation: {
    label: "Awaiting expert confirmation",
    chipClass: "bg-amber-50 text-amber-700 border-amber-200",
    dotClass: "bg-amber-500",
  },
  completed: {
    label: "Resolved",
    chipClass: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dotClass: "bg-emerald-500",
  },
  unresolved: {
    label: "Closed unresolved",
    chipClass: "bg-rose-50 text-rose-700 border-rose-200",
    dotClass: "bg-rose-500",
  },
  cancelled: {
    label: "Cancelled",
    chipClass: "bg-slate-50 text-slate-600 border-slate-200",
    dotClass: "bg-slate-400",
  },
};

const FALLBACK = {
  label: "Open",
  chipClass: "bg-slate-50 text-slate-700 border-slate-200",
  dotClass: "bg-slate-400",
};

/**
 * @param {string} status
 * @param {"client"|"expert"} [viewerRole] Adjusts wording of the two
 *   confirmation states so each side reads its own outstanding action.
 */
export function getStatusMeta(status, viewerRole) {
  const meta = STATUS_META[status] || FALLBACK;

  if (status === "waiting_client_confirmation") {
    return {
      ...meta,
      label:
        viewerRole === "client"
          ? "Awaiting your confirmation"
          : "Awaiting customer confirmation",
    };
  }
  if (status === "waiting_expert_confirmation") {
    return {
      ...meta,
      label:
        viewerRole === "expert"
          ? "Awaiting your confirmation"
          : "Awaiting expert confirmation",
    };
  }
  return meta;
}

/** Statuses where the incident is still live work. */
export const ACTIVE_STATUSES = [
  "open",
  "assigned",
  "in-progress",
  "waiting_client_confirmation",
  "waiting_expert_confirmation",
];

export function isActiveStatus(status) {
  return ACTIVE_STATUSES.includes(status);
}
